import React, { useEffect, useState } from "react";
import { Loader } from "./loader";
import api from "../../api";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export const DataInfoSupport = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  const getTickets = async () => {
    try {
      setLoader(true);
      const response = await api.getDataInfoSupport({ page: 1 });
      setData(response);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getTickets();
  }, []);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid payHistoryPage">
        <div className="row analytics-row">
          <AnalyticsBox
            icon={<i className="fa-solid fa-users"></i>}
            title="All Tickets"
            amount={data?.allTicketCount}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-clock-rotate-left"></i>}
            title="Pending Tickets"
            amount={data?.pendingTicketCount}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-gears"></i>}
            title="Processing Tickets"
            amount={data?.openTicketCount}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-check-double"></i>}
            title="Resolved Tickets"
            amount={data?.closedTicketCount}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user"></i>}
            title="Account Issue"
            amount={data?.accountTicketCount}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-money-bill-1-wave"></i>}
            title="Payment Issue"
            amount={data?.paymentTicketCount}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-gear"></i>}
            title="Technical Issue"
            amount={data?.technicalTicketCount}
          />
        </div>
        <div className="row">
          <div className="col">
            <h3>Recent Tickets</h3>
            <Table data={data?.recentUser ? data?.recentUser : []} />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
};

function AnalyticsBox(props) {
  return (
    <div className="col-xl-3 col-md-6 mb-4">
      <div className="card h-100 py-2 border-transparent br-10">
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col">
              {/* <img className="analytic-box-img" src={props.icon} alt="" /> */}
              <div className="analytic-box-img">{props.icon}</div>
            </div>
            <div className="col-auto mr-2">
              <div className="text-xs font-weight-bold  mb-1">
                <span className="analytics-box-title">{props.title}</span>
              </div>
              <div className="h3 mb-0 font-weight-bold text-gray-800">
                {props.amount}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Table = ({ data }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const navigate = useNavigate();

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent p-0">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Issue ID
                  </th>
                  <th scope="col" className="">
                    Image
                  </th>
                  <th scope="col" className="">
                    User Email
                  </th>
                  <th scope="col" className="">
                    Status
                  </th>
                  <th scope="col" className="">
                    Issue Type
                  </th>
                  <th scope="col" className="">
                    Created At
                  </th>
                  <th scope="col" className="">
                    View
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.issueId}
                      </div>
                    </td>
                    <td>
                      {item?.imageTitle ? (
                        <div
                          className="pImage"
                          style={{ maxWidth: 120, padding: 5 }}
                        >
                          <img
                            src={`${process.env.REACT_APP_S3URL}/img_${item?.imageTitle}.${item.imageFormat}`}
                            alt=""
                          />
                        </div>
                      ) : (
                        <div className="text-center">-</div>
                      )}
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.userId?.email}
                      </div>
                    </td>
                    <td scope="row">
                      <div
                        className={
                          item?.status == "pending"
                            ? "red table-text-dark w-max-c db"
                            : item?.status == "processing"
                            ? " yellow table-text-dark w-max-c db"
                            : "green table-text-dark w-max-c db"
                        }
                      >
                        {item?.status}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.issueType}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </span>
                    </td>
                    <td>
                      <i
                        className="fa-solid fa-eye cursor-pointer"
                        onClick={() =>
                          navigate(`/admin/support/ticket/${item?.issueId}`)
                        }
                      ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
